import axios from "axios";
import {DOMAINS_REQUEST} from "../store/actions/domains";

export default {
    deleteDomain(app, domainId) {
        return new Promise((resolve, reject) => {
            axios.delete('/api/domain/delete/' + domainId)
                .then(function () {
                    // Обновляем список доменов
                    // noinspection JSIgnoredPromiseFromCall
                    app.$store.dispatch(DOMAINS_REQUEST);
                    resolve();
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },
}